// import { useEffect, useState, type JSX } from 'react';
// import RatingsBarChart from '@/pages/user/components/RatingsBarChart';
// import {
//   useLazyGetMyMonthlyPredictionQuery,
//   useLazyGetMyNextMonthlyPredictionQuery,
//   useLazyGetPredictionByPeriodQuery,
// } from '@/store/api/mePredictionMonthly/mepredictionapi';

// import AudioVisualizer from '@/pages/user/components/AudioVisualizer';
// import { useLazyGetPredictionAudioQuery } from '@/store/api/PredictionAudio/predictionaudioApi';
// import Loader from '@/components/Loader';
// import Modal from '@/utils/modal.utils';

// interface MonthlyPredictionProps {
//   fetchedId: string;
//   apiData: any;
//   receivedResponse: boolean;
//   rashiCharts?: {
//     south?: string;
//     north?: string;
//   };
// }

// interface HoroscopeData {
//   title: string;
//   content: string;
// }

// interface Ratings {
//   overall: number;
//   wealth_investments: number;
//   career_profession: number;
//   education: number;
//   health: number;
//   relationships: number;
//   children: number;
// }

// const formatMonthlyPrediction = (raw?: string): HoroscopeData[] => {
//   if (!raw) return [];

//   try {
//     const parsed = JSON.parse(raw);
//     const formatted: HoroscopeData[] = [];

//     Object.entries(parsed).forEach(([key, value]: any) => {
//       if (key === 'ratings') return;

//       if (value?.title && typeof value?.content === 'string') {
//         formatted.push({ title: value.title, content: value.content });
//         return;
//       }

//       if (value?.title && Array.isArray(value?.content)) {
//         formatted.push({
//           title: value.title,
//           content: JSON.stringify({
//             type: 'bullets',
//             items: value.content,
//           }),
//         });
//         return;
//       }

//       if (key === 'caution_and_remedies' && value?.title) {
//         const clean = (text: string) => text.replace(/^[•\-–]\s*/g, '').trim();

//         formatted.push({
//           title: value.title,
//           content: JSON.stringify({
//             type: 'grouped-bullets',
//             groups: [
//               value.caution_periods?.length
//                 ? {
//                     subtitle: 'Caution Periods',
//                     items: value.caution_periods.map(clean),
//                   }
//                 : null,
//               value.remedies?.length
//                 ? {
//                     subtitle: 'Remedies',
//                     items: value.remedies.map(clean),
//                   }
//                 : null,
//             ].filter(Boolean),
//           }),
//         });
//       }
//     });

//     return formatted;
//   } catch (e) {
//     console.error('Monthly prediction parse error', e);
//     return [];
//   }
// };

// export default function MonthlyPrediction({
//   receivedResponse,
//   rashiCharts,
// }: MonthlyPredictionProps): JSX.Element {
//   const [ratings, setRatings] = useState<Ratings | null>(null);
//   const [loading, setLoading] = useState(false);
//   const [monthlyPrediction, setMonthlyPrediction] = useState<HoroscopeData[]>(
//     []
//   );
//   const [charts, setCharts] = useState<{ south?: string; north?: string }>({});
//   const [audioSrc, setAudioSrc] = useState<string | null>(null);
//   const [monthlyView, setMonthlyView] = useState<'current' | 'next'>('current');

//     const [modalOpen, setModalOpen] = useState(false);
//     const [modalImages, setModalImages] = useState<string[]>([]);
//     const [selectedTitle, setSelectedTitle] = useState('');

//     const [textStatus, setTextStatus] = useState<
//   'PENDING' | 'SUCCESS' | 'FAILED' | ''
// >('');

//   const isMonthlyUILoading =
//   loading || Object.keys(charts).length === 0;

//   const openModal = (images: (string | undefined)[], title: string) => {
//   setModalImages(images.filter(Boolean) as string[]);
//   setSelectedTitle(title);
//   setModalOpen(true);
// };

//   const reloadMonthlyPrediction = () => {
//   setMonthlyPrediction([]);
//   setRatings(null);
//   setAudioSrc(null);
//   setTextStatus('PENDING');
// };

//   useEffect(() => {
//     return () => {
//       if (audioSrc) {
//         URL.revokeObjectURL(audioSrc);
//       }
//     };
//   }, [audioSrc]);

//   useEffect(() => {
//     async function fetchMyMonthlyPredictionData() {
//       if (!receivedResponse) return;

//       try {
//         setLoading(true);

//         const res =
//   monthlyView === 'current'
//     ? await fetchMyMonthlyPrediction()
//     : await fetchMyNextMonthlyPrediction();

//         if (!res.success || !res.data?.prediction) {
//           setMonthlyPrediction([]);
//           setRatings(null);
//           setTextStatus('FAILED');
//           return;
//         }

//         let parsed: any;
//         try {
//           parsed = JSON.parse(res.data.prediction);
//         } catch (e) {
//           console.error('Monthly prediction JSON parse error', e);
//           setRatings(null);
//           setMonthlyPrediction([]);
//           return;
//         }

//         if (parsed?.ratings) {
//           const r = parsed.ratings;

//           setRatings({
//             overall: r.overall ?? 0,
//             wealth_investments: r.wealth_investments ?? 0,
//             career_profession: r.career_profession ?? 0,
//             education: r.education ?? 0,
//             health: r.health ?? 0,
//             relationships: r.relationships ?? 0,
//             children: r.children ?? 0,
//           });
//         } else {
//           setRatings(null);
//         }

//         setMonthlyPrediction(formatMonthlyPrediction(res.data.prediction));
//         setTextStatus('SUCCESS');

//         if (res.data.id) {
//           try {
//             const audioRes = await fetchPredictionAudio(res.data.id);
//               if (audioRes.success && audioRes.data?.url) {
//                 setAudioSrc(audioRes.data.url);
//               } else {
//                 setAudioSrc(null);
//               }

//           } catch (e) {
//             console.error('Monthly audio fetch failed', e);
//             setAudioSrc(null);
//           }
//         } else {
//           setAudioSrc(null);
//         }
//       } catch (err) {
//         console.error('My monthly prediction fetch failed:', err);
//         setMonthlyPrediction([]);
//         setRatings(null);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchMyMonthlyPredictionData();
//   }, [receivedResponse, monthlyView]);

//   useEffect(() => {
//     async function fetchMonthlyTransitCharts() {
//       if (!receivedResponse) return;

//       try {
//         const period =
//   monthlyView === 'current' ? 'CurrentMonth' : 'NextMonth';

// const res = await fetchPredictionByPeriod(period);

//         if (!res.success || !res.data?.charts) {
//           setCharts({});
//           return;
//         }

//         setCharts({
//           south: res.data.charts.find((c: any) => c.chartType === 'south')
//             ?.imageUrl,
//           north: res.data.charts.find((c: any) => c.chartType === 'north')
//             ?.imageUrl,
//         });
//       } catch (err) {
//         console.error('Monthly transit charts fetch failed:', err);
//         setCharts({});
//       }
//     }

//     fetchMonthlyTransitCharts();
//  }, [receivedResponse, monthlyView]);

//   const getCurrentMonthLabel = () => {
//   return new Date().toLocaleString('default', { month: 'long' });
// };

// const getNextMonthLabel = () => {
//   const d = new Date();
//   return new Date(d.getFullYear(), d.getMonth() + 1, 1).toLocaleString(
//     'default',
//     { month: 'long' }
//   );
// };
//  return (
//   <section className="w-full max-w-[1600px] mx-auto rounded-xl  lg:p-6">

//     {/* Monthly Tabs */}
// <div className="flex justify-center gap-4 mb-6">
//   <button
//     onClick={() => setMonthlyView('current')}
//     className={`px-6 py-2 rounded-lg font-semibold transition-all ${
//       monthlyView === 'current'
//         ? 'bg-gradient-to-r from-[#082261] to-[#34065c] text-white'
//         : 'bg-white inner-shadow-blue text-black'
//     }`}
//   >
//     {getCurrentMonthLabel()}
//   </button>

//   <button
//     onClick={() => setMonthlyView('next')}
//     className={`px-6 py-2 rounded-lg font-semibold transition-all ${
//       monthlyView === 'next'
//         ? 'bg-gradient-to-r from-[#082261] to-[#34065c] text-white'
//         : 'bg-white inner-shadow-blue text-black'
//     }`}
//   >
//     {getNextMonthLabel()}
//   </button>
// </div>

//    {isMonthlyUILoading ? (
//     <Loader />
// ) : (
//       <>
//       {textStatus === 'SUCCESS' &&
//     rashiCharts &&
//     (rashiCharts.south || rashiCharts.north) && (
//         <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 md:gap-6 items-stretch border border-[#2DAAFD] md:py-10">

//             <div className="flex flex-col order-1 col-span-1 gap-6 md:order-none">
//               <h4 className="font-spectral font-semibold text-[#001B6B] text-center text-lg mt-4 lg:mt-0">
//                 Rashi Charts
//               </h4>

//               <div className="flex flex-col overflow-hidden rounded-xl">
//                 {['south', 'north'].map((dir) => (
//                   <div key={dir} className="p-4">
//                     {(rashiCharts as any)[dir] ? (
//                     <img
//                       src={(rashiCharts as any)[dir]}
//                       alt={`Monthly Rashi ${dir} Chart`}
//                       className="w-full h-full rounded-md p-2 border border-[#2DAAFD] cursor-pointer"
//                       onClick={() =>
//                         openModal(
//                           [rashiCharts?.south, rashiCharts?.north],
//                           'Rashi Chart (South Indian & North Indian)'
//                         )
//                       }
//                     />

//                     ) : (
//                       <div className="h-[240px] flex items-center justify-center text-sm text-gray-500">
//                         Chart not available
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>

//                     {ratings && (
//               <div className="order-3 col-span-1 p-4 rounded-xl md:col-span-2 md:order-none">
//                 <RatingsBarChart ratings={ratings} custom={true} />

//                 {audioSrc && (
//                   <div className="order-4 block col-span-4 md:hidden xl:block md:mt-18 lg:mt-26 xl:mt-14 md:order-none">
//                     <AudioVisualizer audioSrc={audioSrc} />

//                     <p className="mt-6 md:mt-10 text-center text-[12px] md:text-[16px] text-gray-800 font-medium">
//                       Click Play to hear your personalized predictions.
//                     </p>
//                   </div>
//                 )}
//               </div>
//             )}

//           <div className="flex flex-col order-2 col-span-1 gap-6 md:order-none">
//             <h4 className="font-spectral font-semibold text-[#001B6B] text-center text-lg mt-4 lg:mt-0">
//               Transit Charts
//             </h4>

//             <div className="flex flex-col overflow-hidden rounded-xl">
//               {['south', 'north'].map((dir) => (
//                 <div key={dir} className="p-4">
//                   {(charts as any)[dir] ? (
//                    <img
//                   src={(charts as any)[dir]}
//                   alt={`Transit ${dir} Chart`}
//                   className="w-full aspect-square object-contain rounded-md border border-[#2DAAFD] p-2 cursor-pointer"
//                   onClick={() =>
//                     openModal(
//                       [charts?.south, charts?.north],
//                       'Transit Chart (South Indian & North Indian)'
//                     )
//                   }
//                 />

//                   ) : (
//                     <div className="h-[240px] flex items-center justify-center text-sm text-gray-500">
//                       Chart not available
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>

//             <div className="hidden col-span-4 md:block xl:hidden">
//             {audioSrc && (
//               <div>
//                 <AudioVisualizer audioSrc={audioSrc} />

//                 <p className="mt-6 text-center text-[12px] md:text-[13px] text-gray-600 font-medium">
//                   Click Play to hear your personalized predictions.
//                 </p>
//               </div>
//             )}
//           </div>

//         </div>
//     )}

//                 { textStatus === 'FAILED' ? (
//             <div className="text-center text-[#082261] font-spectral text-lg mt-10">
//               Predictions are not visible, please click the Reload button.
//               <br />
//               <button
//                 onClick={reloadMonthlyPrediction}
//                 className="mt-4 px-6 py-2 bg-[#082261] text-white rounded-lg font-spectral"
//               >
//                 Reload Prediction
//               </button>
//             </div>
//           ) : textStatus === 'PENDING' ? (
//             <div className="text-center text-[#082261] font-spectral text-lg mt-10">
//               This takes a little time as we analyze your unique patterns to build your
//               custom prediction.
//             </div>
//           ) : monthlyPrediction.length > 0 ? (
//             <div className="mt-10 space-y-6">

//             {monthlyPrediction.map((section, idx) => {
//               let parsedContent: any = null;
//               try {
//                 parsedContent = JSON.parse(section.content);
//               } catch {}

//               return (
//                 <section key={idx}>
//                   <h3 className="font-spectral text-[#001B6B] font-semibold text-[20px] uppercase tracking-wide">
//                     {section.title}
//                   </h3>

//                   {parsedContent?.type === 'grouped-bullets' ? (
//                   <div className="mt-3 space-y-4">
//                     {parsedContent.groups.map(
//                       (
//                         group: { subtitle: string; items: string[] },
//                         gi: number
//                       ) => (
//                         <div key={gi}>
//                           <h4 className="font-lato font-semibold text-[18px] text-[#001B6B] mb-2">
//                             {group.subtitle}
//                           </h4>
//                           <ul className="pl-6 space-y-2 list-disc">
//                             {group.items.map((item: string, i: number) => (
//                               <li
//                                 key={i}
//                                 className="font-lato text-[#333333] text-[17px] leading-relaxed"
//                               >
//                                 {item}
//                               </li>
//                             ))}
//                           </ul>
//                         </div>
//                       )
//                     )}
//                   </div>
//                 ) :parsedContent?.type === 'bullets' ? (
//                         <div className="mt-3 space-y-3">
//                           {parsedContent.items.map(
//                             (item: string, i: number) => {
//                               const [label, ...rest] = item.split(':');
//                               const hasLabel = [
//                                 'education',
//                                 'health',
//                                 'relationships',
//                                 'children',
//                               ].includes(label?.trim().toLowerCase());

//                               return (
//                                 <p
//                                   key={i}
//                                   className="font-lato text-[#333333] text-[18px] leading-relaxed"
//                                 >
//                                   {hasLabel ? (
//                                     <>
//                                       <span className="font-lato font-semibold text-[#001B6B]">
//                                         {label.trim()}:
//                                       </span>{' '}
//                                       {rest.join(':').trim()}
//                                     </>
//                                   ) : (
//                                     item
//                                   )}
//                                 </p>
//                               );
//                             }
//                           )}
//                         </div>
//                       ) : (
//                     <p className="font-lato text-[#333333] text-[18px] leading-relaxed mt-2">
//                       {section.content}
//                     </p>
//                   )}
//                 </section>
//               );
//             })}
//           </div>
//         ) : (
//           <div className="text-center text-[#082261] font-spectral text-lg mt-10">
//             Monthly predictions are not available.
//             <br />
//             <button
//               onClick={reloadMonthlyPrediction}
//               className="mt-4 px-6 py-2 bg-[#082261] text-white rounded-lg font-spectral"
//             >
//               Reload Prediction
//             </button>
//           </div>
//         )}
//       </>
//     )}

//          <Modal
//         open={modalOpen}
//         onClose={() => setModalOpen(false)}
//         title={selectedTitle}
//         widthClass="max-w-3xl"
//       >
//         <div className="flex flex-col gap-4 md:flex-row">
//           {modalImages.map((img, i) => (
//             <img
//               key={i}
//               src={img}
//               alt="Chart"
//               className={`w-full rounded-md ${i === 1 ? 'scale-[1.05]' : ''}`}
//             />
//           ))}
//         </div>
//       </Modal>

//   </section>
// );

// }

import { useEffect, useRef, useState, type JSX } from 'react';
import RatingsBarChart from '@/pages/user/components/RatingsBarChart';
import {
  useLazyGetMyMonthlyPredictionQuery,
  useLazyGetMyNextMonthlyPredictionQuery,
  useLazyGetPredictionByPeriodQuery,
} from '@/store/api/mePredictionMonthly/mepredictionapi';

import AudioVisualizer from '@/pages/user/components/AudioVisualizer';
import { useLazyGetPredictionAudioQuery } from '@/store/api/PredictionAudio/predictionaudioApi';
import Loader from '@/components/Loader';
import Modal from '@/utils/modal.utils';
import { SegmentedControl } from '@/components/ui/SegmentedControl';

interface MonthlyPredictionProps {
  fetchedId: string;
  apiData: any;
  receivedResponse: boolean;
  language: string;
  rashiCharts?: {
    south?: string;
    north?: string;
  };
}

interface HoroscopeData {
  title: string;
  content: string;
}

interface Ratings {
  overall: number;
  wealth_investments: number;
  career_profession: number;
  education: number;
  health: number;
  relationships: number;
  children: number;
}

const formatMonthlyPrediction = (raw?: string): HoroscopeData[] => {
  if (!raw) return [];

  const normalizeTitle = (key: string): string => {
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const cleanBullet = (text: string) => text.replace(/^[•\-–]\s*/, '').trim();

  try {
    const rawParsed = JSON.parse(raw);
    const formatted: HoroscopeData[] = [];

    let mainData = rawParsed.prediction || rawParsed;
    if (mainData.prediction) mainData = mainData.prediction;
    if (mainData.predictions) mainData = mainData.predictions;

    const heading =
      rawParsed.heading ||
      mainData.heading ||
      mainData.title ||
      mainData.monthly_forecast ||
      (rawParsed.prediction && rawParsed.prediction.heading);
    if (heading) {
      formatted.push({ title: 'HEADING', content: heading });
    }

    Object.entries(mainData).forEach(([key, value]: any) => {
      if (
        [
          'ratings',
          'heading',
          'title',
          'monthly_forecast',
          'videoId',
          'videoUrl',
          'userId',
        ].includes(key)
      )
        return;

      // Special handling for Education, Health and Momentum as requested
      if (key === 'health_and_education' || key === 'health_education') {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          const items = Object.entries(value)
            .filter(([k, v]) => v && typeof v === 'string' && k !== 'title')
            .map(([k, v]) => `${normalizeTitle(k)}: ${cleanBullet(v as string)}`);
          if (items.length > 0) {
            formatted.push({
              title: 'HEALTH AND EDUCATION',
              content: JSON.stringify({ type: 'bullets', items }),
            });
          }
        }
        return;
      }

      if (key === 'monthly_phases_and_momentum' || key === 'monthly_phases_momentum') {
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
          const items = Object.entries(value)
            .filter(([k, v]) => v && typeof v === 'string' && k !== 'title')
            .map(([k, v]) => `${normalizeTitle(k)}: ${cleanBullet(v as string)}`);
          if (items.length > 0) {
            formatted.push({
              title: 'MONTHLY PHASES MOMENTUM',
              content: JSON.stringify({ type: 'bullets', items }),
            });
          }
        }
        return;
      }

      if (typeof value === 'string' && key !== 'content') {
        formatted.push({
          title: normalizeTitle(key),
          content: value,
        });
        return;
      }

      if (key === 'content' && typeof value === 'string') {
        formatted.push({
          title: 'Overview',
          content: value,
        });
        return;
      }

      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (
          key.toLowerCase().includes('caution') ||
          key.toLowerCase().includes('remedy') ||
          key.toLowerCase().includes('remedies')
        ) {
          const cautionText = value.periods_of_caution || value.caution_periods || value.caution;
          const remedies = value.remedies || value.suggested_remedies || value.remedy;

          const groups = [
            cautionText
              ? {
                  subtitle: 'Caution Periods',
                  items: Array.isArray(cautionText)
                    ? cautionText.filter(Boolean).map(cleanBullet)
                    : [cleanBullet(String(cautionText))],
                }
              : null,
            remedies
              ? {
                  subtitle: 'Remedies',
                  items: Array.isArray(remedies)
                    ? remedies.filter(Boolean).map(cleanBullet)
                    : [cleanBullet(String(remedies))],
                }
              : null,
          ].filter(Boolean);

          if (groups.length > 0) {
            formatted.push({
              title: 'PERIODS OF CAUTION AND REMEDIES',
              content: JSON.stringify({ type: 'grouped-bullets', groups }),
            });
          }
          return;
        }

        // Preserve Parent Header
        formatted.push({ title: normalizeTitle(key), content: '' });

        Object.entries(value).forEach(([subKey, subValue]: any) => {
          if (subKey === 'title' || subKey === 'heading') return;

          // Nested special handling
          if (
            subKey === 'health_and_education' ||
            subKey === 'health_education' ||
            subKey === 'monthly_phases_and_momentum' ||
            subKey === 'monthly_phases_momentum'
          ) {
            if (typeof subValue === 'object' && subValue !== null && !Array.isArray(subValue)) {
              const items = Object.entries(subValue)
                .filter(([k, v]) => v && typeof v === 'string' && k !== 'title')
                .map(([k, v]) => `${normalizeTitle(k)}: ${cleanBullet(v as string)}`);
              if (items.length > 0) {
                formatted.push({
                  title: normalizeTitle(subKey).toUpperCase(),
                  content: JSON.stringify({ type: 'bullets', items }),
                });
                return;
              }
            }
          }

          const content = Array.isArray(subValue)
            ? JSON.stringify({ type: 'bullets', items: subValue.map(cleanBullet) })
            : typeof subValue === 'string'
              ? subValue
              : JSON.stringify(subValue);

          formatted.push({
            title: normalizeTitle(subKey),
            content,
          });
        });
        return;
      }

      if (Array.isArray(value)) {
        formatted.push({
          title: normalizeTitle(key),
          content: JSON.stringify({
            type: 'bullets',
            items: value.map(cleanBullet),
          }),
        });
        return;
      }
    });

    return formatted;
  } catch (e) {
    console.error('Monthly prediction parse error', e);
    return [];
  }
};

export default function MonthlyPrediction({
  receivedResponse,
  rashiCharts,
  fetchedId,
  language,
}: MonthlyPredictionProps): JSX.Element {
  const [ratings, setRatings] = useState<Ratings | null>(null);
  const [loading, setLoading] = useState(false);
  const [monthlyPrediction, setMonthlyPrediction] = useState<HoroscopeData[]>([]);
  const [charts, setCharts] = useState<{ south?: string; north?: string }>({});
  const [audioSrc, setAudioSrc] = useState<string | null>(null);
  const [monthlyView, setMonthlyView] = useState<'current' | 'next'>('current');

  const [modalOpen, setModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState<string[]>([]);
  const [selectedTitle, setSelectedTitle] = useState('');

  const [textStatus, setTextStatus] = useState<'PENDING' | 'SUCCESS' | 'FAILED' | ''>('');
  const [predictionId, setPredictionId] = useState<string | null>(null);

  const [triggerCurrentMonth] = useLazyGetMyMonthlyPredictionQuery();

  const [triggerNextMonth] = useLazyGetMyNextMonthlyPredictionQuery();

  const [triggerPredictionPeriod] = useLazyGetPredictionByPeriodQuery();

  const [triggerAudio] = useLazyGetPredictionAudioQuery();
  const [audioLoading, setAudioLoading] = useState(false);
  const [audioError, setAudioError] = useState<string | null>(null);

  const audioPollingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (audioPollingTimeoutRef.current) clearTimeout(audioPollingTimeoutRef.current);
    };
  }, []);

  const fetchAudioWithPolling = async (predictionId: string, retryCount = 0) => {
    if (audioPollingTimeoutRef.current) clearTimeout(audioPollingTimeoutRef.current);
    setAudioLoading(true);
    setAudioError(null);
    try {
      const audioRes = await triggerAudio({
        predictionId,
        language: 'English',
      }).unwrap();

      const rawStatus = audioRes?.status;
      const status = typeof rawStatus === 'string' ? rawStatus.toUpperCase() : '';

      if (audioRes?.url) {
        setAudioSrc(audioRes.url);
        setAudioLoading(false);
        return;
      }

      if (status === 'DRAFT') {
        setAudioError(audioRes?.message || 'Audio not generated yet');
        setAudioLoading(false);
        return;
      }

      if (status === 'FAILED') {
        if (retryCount < 4) {
          audioPollingTimeoutRef.current = setTimeout(
            () => fetchAudioWithPolling(predictionId, retryCount + 1),
            2000
          );
        } else {
          setAudioError('Audio generation failed.');
          setAudioLoading(false);
        }
        return;
      }

      // If pending or no url, poll after 2 seconds
      audioPollingTimeoutRef.current = setTimeout(
        () => fetchAudioWithPolling(predictionId, retryCount),
        2000
      );
    } catch (err: any) {
      console.error('Audio fetch error:', err);

      const rawStatus = err?.data?.status;
      const status = typeof rawStatus === 'string' ? rawStatus.toUpperCase() : '';

      if (status === 'DRAFT') {
        setAudioError(err?.data?.message || 'Audio not generated yet');
        setAudioLoading(false);
        return;
      }

      if (status === 'FAILED') {
        if (retryCount < 4) {
          audioPollingTimeoutRef.current = setTimeout(
            () => fetchAudioWithPolling(predictionId, retryCount + 1),
            2000
          );
        } else {
          setAudioError('Audio generation failed.');
          setAudioLoading(false);
        }
        return;
      }

      // Handle server-side 500 error or other failed generations
      if (
        err?.status === 500 ||
        rawStatus === 500 ||
        String(err?.data?.message || '')
          .toLowerCase()
          .includes('fail')
      ) {
        setAudioError(err?.data?.message || 'Audio failed to generate.');
        setAudioLoading(false);
        return;
      }

      if (retryCount < 5) {
        audioPollingTimeoutRef.current = setTimeout(
          () => fetchAudioWithPolling(predictionId, retryCount + 1),
          2000
        );
      } else {
        setAudioError(err?.data?.message || 'Audio generation failed. Please retry.');
        setAudioLoading(false);
      }
    }
  };

  const isMonthlyUILoading = loading || Object.keys(charts).length === 0;

  const openModal = (images: (string | undefined)[], title: string) => {
    setModalImages(images.filter(Boolean) as string[]);
    setSelectedTitle(title);
    setModalOpen(true);
  };

  const reloadMonthlyPrediction = () => {
    setMonthlyPrediction([]);
    setRatings(null);
    setAudioSrc(null);
    setPredictionId(null);
    setTextStatus('PENDING');
  };

  useEffect(() => {
    return () => {
      if (audioSrc) {
        URL.revokeObjectURL(audioSrc);
      }
    };
  }, [audioSrc]);

  useEffect(() => {
    async function fetchMyMonthlyPredictionData() {
      if (!receivedResponse) return;

      try {
        setLoading(true);
        setTextStatus('PENDING');

        const res =
          monthlyView === 'current'
            ? await triggerCurrentMonth({ userId: fetchedId, language }).unwrap()
            : await triggerNextMonth({ userId: fetchedId, language }).unwrap();

        const rawRes = res as any;
        const container = rawRes?.prediction || rawRes?.data;

        if (!container || !container.prediction) {
          setMonthlyPrediction([]);
          setRatings(null);
          setTextStatus('FAILED');
          return;
        }

        let parsed: any;

        if (typeof container.prediction === 'string') {
          try {
            parsed = JSON.parse(container.prediction);
          } catch (e) {
            console.error('Monthly prediction JSON parse error', e);
            setRatings(null);
            setMonthlyPrediction([]);
            setTextStatus('FAILED');
            return;
          }
        } else {
          parsed = container.prediction;
        }

        if (parsed?.ratings) {
          const r = parsed.ratings;

          setRatings({
            overall: r.overall ?? 0,
            wealth_investments: r.wealth_investments ?? 0,
            career_profession: r.career_profession ?? 0,
            education: r.education ?? 0,
            health: r.health ?? 0,
            relationships: r.relationships ?? 0,
            children: r.children ?? 0,
          });
        } else {
          setRatings(null);
        }

        setMonthlyPrediction(
          formatMonthlyPrediction(
            typeof container.prediction === 'string' ? container.prediction : JSON.stringify(container.prediction)
          )
        );

        setTextStatus('SUCCESS');

        if (container.id) {
          setPredictionId(container.id);
          fetchAudioWithPolling(container.id);
        } else {
          setAudioSrc(null);
        }
      } catch (err) {
        console.error('My monthly prediction fetch failed:', err);
        setMonthlyPrediction([]);
        setRatings(null);
        setTextStatus('FAILED');
      } finally {
        setLoading(false);
      }
    }

    fetchMyMonthlyPredictionData();
  }, [receivedResponse, monthlyView, language]);

  useEffect(() => {
    async function fetchMonthlyTransitCharts() {
      if (!receivedResponse) return;

      try {
        const period = monthlyView === 'current' ? 'CurrentMonth' : 'NextMonth';

        const res = await triggerPredictionPeriod(period).unwrap();

        if (!res?.charts) {
          setCharts({});
          return;
        }

        setCharts({
          south: res.charts.find((c: any) => c.chartType === 'south')?.imageUrl,
          north: res.charts.find((c: any) => c.chartType === 'north')?.imageUrl,
        });
      } catch (err) {
        console.error('Monthly transit charts fetch failed:', err);
        setCharts({});
      }
    }

    fetchMonthlyTransitCharts();
  }, [receivedResponse, monthlyView]);

  const getCurrentMonthLabel = () => {
    return new Date().toLocaleString('default', {
      month: 'long',
    });
  };

  const getNextMonthLabel = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 1).toLocaleString('default', {
      month: 'long',
    });
  };

  return (
    <section className="w-full max-w-[1600px] mx-auto rounded-xl">
      <div className="flex justify-center mb-6">
        <SegmentedControl
          options={[
            { label: getCurrentMonthLabel(), value: 'current' },
            { label: getNextMonthLabel(), value: 'next' },
          ]}
          value={monthlyView}
          onChange={(val) => setMonthlyView(val as 'current' | 'next')}
        />
      </div>

      <>
          {!isMonthlyUILoading && textStatus === 'SUCCESS' && rashiCharts && (rashiCharts.south || rashiCharts.north) && (
            <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 md:gap-6 items-stretch rounded-xl border border-[#2DAAFD]">
              {/* RASHI CHARTS */}
              <div className="flex flex-col col-span-1 gap-6">
                <h4 className="font-spectral font-semibold text-[#001B6B] text-center text-lg mt-4">
                  Rashi Charts
                </h4>

                {['south', 'north'].map((dir) => (
                  <div key={dir} className="p-4">
                    {(rashiCharts as any)[dir] ? (
                      <img
                        src={(rashiCharts as any)[dir]}
                        className="w-full rounded-md border p-2 border-[#2DAAFD] cursor-pointer"
                        onClick={() =>
                          openModal([rashiCharts?.south, rashiCharts?.north], 'Rashi Chart')
                        }
                      />
                    ) : null}
                  </div>
                ))}
              </div>

              {ratings && (
                <div className="col-span-1 p-4 rounded-xl md:col-span-2">
                  <RatingsBarChart ratings={ratings} custom={true} />

                  {(audioLoading || audioError || audioSrc) && (
                    <div className="mt-20">
                      {audioLoading ? (
                        <p className="text-center font-semibold text-[#082261] animate-pulse">
                          Loading your personalized prediction audio...
                        </p>
                      ) : audioError ? (
                        <div className="text-center">
                          <p className="font-medium text-red-500 mb-2">{audioError}</p>
                          {predictionId && (
                            <button
                              onClick={() => fetchAudioWithPolling(predictionId)}
                              className="px-4 py-2 bg-[#082261] text-white text-sm rounded-lg font-spectral hover:bg-[#2DAAFD] transition-colors"
                            >
                              Regenerate Audio
                            </button>
                          )}
                        </div>
                      ) : (
                        <>
                          <AudioVisualizer audioSrc={audioSrc} />
                          <p className="mt-4 text-sm text-center text-gray-600">
                            Click Play to hear your personalized predictions.
                          </p>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="flex flex-col col-span-1 gap-6">
                <h4 className="font-spectral font-semibold text-[#001B6B] text-center text-lg mt-4">
                  Transit Charts
                </h4>

                {['south', 'north'].map((dir) => (
                  <div key={dir} className="p-4">
                    {(charts as any)[dir] ? (
                      <img
                        src={(charts as any)[dir]}
                        className="w-full aspect-square object-contain rounded-md border border-[#2DAAFD] p-2 cursor-pointer"
                        onClick={() => openModal([charts?.south, charts?.north], 'Transit Chart')}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
            </div>
          )}

          {textStatus === 'FAILED' ? (
            <div className="text-center text-[#082261] font-spectral text-lg mt-10">
              Predictions are not visible, please click the Reload button.
              <br />
              <button
                onClick={reloadMonthlyPrediction}
                className="mt-4 px-6 py-2 bg-[#082261] text-white rounded-lg"
              >
                Reload Prediction
              </button>
            </div>
          ) : textStatus === 'PENDING' ? (
            <div className="text-center text-[#082261] font-spectral text-lg mt-10">
              Decoding your unique planetary alignments to craft your personalized prediction. Please wait a moment...
            </div>
          ) : monthlyPrediction.length > 0 && !isMonthlyUILoading ? (
            <div className="mt-10 space-y-6">
              {monthlyPrediction.map((section, idx) => {
                if (section.title === 'HEADING') {
                  return (
                    <h2
                      key={idx}
                      className="font-spectral text-[#001B6B] font-bold text-[22px] uppercase text-center my-6 border-b border-[#001B6B]/20 pb-2"
                    >
                      {section.content}
                    </h2>
                  );
                }

                let parsedContent: any = null;
                try {
                  parsedContent = JSON.parse(section.content);
                } catch {}

                const isSectorLabel = (title: string) => {
                  const normalized = title.trim().toLowerCase();
                  return [
                    'career',
                    'wealth',
                    'money',
                    'relationships',
                    'children',
                    'health',
                    'education',
                    'overview',
                    'general predictions',
                    'sector wise predictions',
                    'phases',
                    'career & profession',
                    'money & investments',
                    'wealth & investments',
                    'health & education',
                    'children creative',
                    'relationships & partnerships',
                    'your monthly predictions',
                    'sector wise predictions',
                    'monthly phases momentum',
                    'phase 1',
                    'phase 2',
                    'phase 3',
                    'wealth investments',
                    'career profession',
                    'relationships partnerships',
                    'children creative endeavors',
                    'health education',
                  ].some((lbl) => normalized.includes(lbl));
                };

                const isParentHeader = section.content === '' && section.title !== '';

                return (
                  <section key={idx}>
                    {isParentHeader ? (
                      <h3 className="font-spectral text-[#001B6B] font-semibold text-[20px] uppercase tracking-wide mt-8 underline decoration-[#001B6B]/30 underline-offset-4">
                        {section.title}
                      </h3>
                    ) : !parsedContent && isSectorLabel(section.title) ? (
                      <p className="font-lato text-[#333333] text-[18px] leading-relaxed mt-3">
                        <span className="font-semibold text-[#001B6B]">{section.title}:</span>{' '}
                        {section.content}
                      </p>
                    ) : (
                      <>
                        {section.title && section.title !== '' && (
                          <h3 className="font-spectral text-[#001B6B] font-semibold text-[20px] uppercase tracking-wide mt-4">
                            {section.title}
                          </h3>
                        )}

                        {parsedContent?.type === 'grouped-bullets' ? (
                          <div className="mt-3 space-y-4">
                            {parsedContent.groups.map((group: any, gi: number) => (
                              <div key={gi} className="mb-4 last:mb-0">
                                {group.subtitle && (
                                  <h4 className="font-lato font-semibold text-[18px] text-[#001B6B] mb-2 capitalize">
                                    {String(group.subtitle).toLowerCase()}
                                  </h4>
                                )}
                                <ul className="pl-6 space-y-2 list-disc">
                                  {group.items.map((item: string, i: number) => (
                                    <li
                                      key={i}
                                      className="font-lato text-[#333333] text-[17px] leading-relaxed"
                                    >
                                      {item}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        ) : parsedContent?.type === 'bullets' ? (
                          <ul
                            className={`pl-6 mt-3 space-y-2 ${['health', 'education', 'momentum', 'children'].some((s) => section.title.toLowerCase().includes(s)) ? 'list-none pl-0' : 'list-disc'}`}
                          >
                            {parsedContent.items.map((item: string, i: number) => {
                              const colonIndex = item.indexOf(':');
                              if (colonIndex > 0 && colonIndex < 35) {
                                const label = item.substring(0, colonIndex).trim();
                                const content = item.substring(colonIndex + 1).trim();

                                const shouldHighlight = [
                                  'education',
                                  'health',
                                  'relationships',
                                  'children',
                                  'wealth & investments',
                                  'career & profession',
                                  'health & education',
                                  'wealth and investments',
                                  'career and profession',
                                  'health and education',
                                  'children creative',
                                  'children creative endeavors',
                                  "children's creative endeavors",
                                  'relationships & partnerships',
                                  'phase 1',
                                  'phase 2',
                                  'phase 3',
                                  'overview',
                                  'general predictions',
                                  'suggested remedies',
                                  'periods of caution',
                                ].includes(label.toLowerCase());

                                if (shouldHighlight) {
                                  return (
                                    <li
                                      key={i}
                                      className="font-lato text-[#333333] text-[18px] leading-relaxed"
                                    >
                                      <span className="font-semibold text-[#001B6B]">{label}:</span>{' '}
                                      {content}
                                    </li>
                                  );
                                }
                              }
                              return (
                                <li
                                  key={i}
                                  className="font-lato text-[#333333] text-[18px] leading-relaxed"
                                >
                                  {item}
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <p className="mt-2 text-[18px] text-[#333333] font-lato leading-relaxed">
                            {section.content}
                          </p>
                        )}
                      </>
                    )}
                  </section>
                );
              })}
            </div>
          ) : null}
      </>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={selectedTitle}
        widthClass="max-w-3xl"
      >
        <div className="flex flex-col gap-4 md:flex-row">
          {modalImages.map((img, i) => (
            <img
              key={i}
              src={img}
              alt="Chart"
              className={`w-full rounded-md ${i === 1 ? 'scale-[1.05]' : ''}`}
            />
          ))}
        </div>
      </Modal>
    </section>
  );
}
